import {Component, Input, OnInit} from '@angular/core';
import {PublicationModel} from '../../../models/publication.model';

@Component({
  selector: 'app-step-registration-done',
  templateUrl: './step-registration-done.component.html',
  styleUrls: ['./step-registration-done.component.scss']
})
export class StepRegistrationDoneComponent implements OnInit {

  @Input() publication: PublicationModel = new PublicationModel();
  constructor() { }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/app/+app-custom/components/publication-registration/step-registration-done/step-registration-done.component.ts